 // here a simpler solution is required:
//  1. ImageUploader component should onlty provide the blob resized Files .
// the rest should be handled on parent level.

import React,{useCallback, useEffect, useState, forwardRef, useImperativeHandle} from "react";

// Page Components:
import UploadButton from "../Buttons/UploadButton";

// MUI Components:
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Box     from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

// react components:
import Resizer from 'react-image-file-resizer';

// Styled comp:
import { styled } from '@mui/material/styles';
import { ServerRouter } from "react-router";


// Icons
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

// model
import  {getAPIGWPath} from '../../../models/model';


/******************************************************
 * Component Style
******************************************************/

    const SectionTitle = styled(Typography) ({
        width:'100%',
        fontWeight:'bold',
        marginBottom:'0.3rem'
    });
    const ControlLabel = styled(Typography) ({
        width:'30%',
        direction:'rtl'
    });

    const CustTextFld =  styled(TextField) ({
        width:'70%',
        size:'small'
    });

    const InfoPanelCntr  = styled(Box) ({
        display:'flex',
        flexDirection:'column',
        width:'maxContent',
        position:'sticky',
        [`& ${ControlLabel}`]: ({})
    }) 

    const InputContainer = styled(FormControl) ({
        width:'100%',
        display:'flex',
        flexDirection:'row',
        [`& ${ControlLabel}`]: ({}),
        [`& ${CustTextFld}`]: ({})
        
        })
    
    const SectionContainer =  styled(Box)({
        width:'100%',
        marginTop:'1rem',
        marginBottom:'1rem',
        [`& ${InputContainer}`]: ({}),
        [`&${InfoPanelCntr}`]: ({})
    });



    const UplBtnCtnr =  styled(Box) ({
        display:'flex',
        gap:'1rem',
        width:'100%'

    });

    const ImgBox =styled(Box)({
        component:"img",
        width:'6rem', 
        height:'6rem'
    });

    const ImgCntnr =  styled(Box)  ({
        display:'flex',
        flexDirection:'column',
        [`& ${ImgBox}`]: ({})
    })

    const SelImagesCtnr =  styled(Box) ({
        display:'flex',
        flexDirection:'row',
        gap:3,
        marginTop:'1.5rem',
        minHeight:'15rem',
        [`& ${ImgCntnr}`]: ({})    
    });


    const ImageUploader6 =  forwardRef( (props, ref) => {

        console.log('re-render conmponent');

        const [filesState,setFilesState] = useState({
            fileList: [],
            fileList64: [],
            stage: {
                    attachReady:false,
                    resizeReady:false,
            },
            stateMsg: ""

        })

        const initState = {
            fileList: [],
            fileList64: [],
            stage: {
                    attachReady:false,
                    resizeReady:false,
            },
            stateMsg: ""
        };

        const aSizeSetting = [
            {w:350,h:350},
            {w:700,h:700},
            {w:1024,h:1024}
        ]; // images sizes: small, medium, large


        useImperativeHandle(ref, () => ({
        // onProcessUpload,
        handleUpload,
        resetMedia
        }));

/**********************************************************************
 * STATE HANDLING
 ***********************************************************************/
    useEffect(() => {

        setFilesState({
            fileList: [],
            fileList64: [],
            stage: {
                    attachReady:false,
                    resizeReady:false,
                    signReady  :false,
                    uploadReady:false,
                    dbSaveReady:false
            },
            stateMsg: ""
        });

    },[])

    useEffect(() => {
        props.provideFileList(filesState);

    },[filesState,props])



/**********************************************************************
 * EVENT HANDLING
 ********************************************************************** */

    const onFileChange = async (oEvent) => {

        let aSelFiles = Array.from(oEvent.target.files);
            await resizeImages(aSelFiles);  
    }

    const resizeImages =  async (aFiles) => {

        let oFile     = aFiles[0],
            oPrmFile  = {},
            aPrmFiles = [],
            aResFiles = [],
            prmS,_prmS,
            prmM,_prmM,
            prmL,_prmL;

            
        if(aFiles.length === 0) {
            alert('no files have been selected');
            return;
        }

        aFiles.forEach((oFile) => {
            let obj = {};
            let fileName =  oFile.name;

            let aPromises =  aSizeSetting.map((stng) => {
                let prmResize = resizeFile(oFile,stng['w'],stng['h'],"JPEG",100,"base64");
                return(prmResize);
            });

        obj.name     = fileName;
        obj.promises = aPromises;
        obj.origFile    = oFile;
        
        aPrmFiles.push(obj);

    });

        let _aPrmFilesTerm = _promiseTerminate(aPrmFiles);

        await _aPrmFilesTerm;

        console.log("resizing job is done");

    }

    const resizeFile = (file,vWidth,vHeight, sfileType,iQlty,sOtpFormat) => {
            return new Promise( (resolve) => {
                    Resizer.imageFileResizer(
                        file,          // Is the file of the image which will be resized
                        vWidth,           // Max width
                        vHeight,           // Max height
                        sfileType,        // Compress format(PNG, JPEG, WEBP)
                        iQlty,           // Quality(0-100)
                        0,             // Rotation
                        (uri) => {     // Callback function of the resized new image URI
                            resolve(uri);
                            // console.log('resized' + " " +  vWidth.toString())
                        },
                        sOtpFormat  //"base64"
                    );
        })
    };

    const handleUpload =  async (_id) => {
        // oEvent.preventDefault();
        let sPath = getAPIGWPath('/aws_s3/uploadURL'),
            aUrlParams = [],
            aReqUrl    = [],
            aSignedUrl = [],
            aFileList  = filesState['fileList'],
            oStage     = filesState['stage'];

            // filesState.fileList
        try {

            // prepare reqURl
            for(let i = 0; i < aFileList.length; i++) {

                let oFile = aFileList[i];

                // prepare reqUrl
                const urlparam_s = new URLSearchParams({objId: _id, size:'small' });
                const urlparam_m = new URLSearchParams({objId: _id, size:'medium'});
                const urlparam_l = new URLSearchParams({objId: _id, size:'large'});

                aUrlParams = [];
                aUrlParams.push(urlparam_s);
                aUrlParams.push(urlparam_m);
                aUrlParams.push(urlparam_l);

                aReqUrl = [];
                aReqUrl.push(`${sPath}?${urlparam_s}`);
                aReqUrl.push(`${sPath}?${urlparam_m}`);
                aReqUrl.push(`${sPath}?${urlparam_l}`);

                aFileList[i].reqURls = aReqUrl;

            };

            // sign url
            for(let i = 0; i < aFileList.length; i++) {

                let oFile = aFileList[i];

                let   _signUrl_s = fetch(oFile.reqURls[0]);
                let   _signUrl_m = fetch(oFile.reqURls[1]);
                let   _signUrl_l = fetch(oFile.reqURls[2]);

                let   signUrl_s =  await _signUrl_s;
                let   signUrl_m =  await _signUrl_m;
                let   signUrl_l =  await _signUrl_l;

                let   resJSON_s = await signUrl_s.json();
                let   resJSON_m = await signUrl_m.json();
                let   resJSON_l = await signUrl_l.json();

                aSignedUrl = [];
                aSignedUrl.push(resJSON_s);
                aSignedUrl.push(resJSON_m);
                aSignedUrl.push(resJSON_l);

                aFileList[i].signedUrls = aSignedUrl;
                oStage.signReady        = true;

                // setFileState({...fileState,  signReady: aResFiles.length === i+1 ? true : false });   
                // setResFiles(aResFiles);
            };


            //upload
            for(let i = 0; i < aFileList.length; i++) {

                let oFile = aFileList[i],
                    aUpldUrl,
                    _upld_s,
                    _upld_m,
                    _upld_l,
                    upld_s,
                    upld_m,
                    upld_l;

                    _upld_s =  fetch(oFile.signedUrls[0].url, { method: 'PUT', body: oFile.files[0] });
                    _upld_m =  fetch(oFile.signedUrls[1].url, { method: 'PUT', body: oFile.files[1] });
                    _upld_l =  fetch(oFile.signedUrls[2].url, { method: 'PUT', body: oFile.files[2] });

                    aUpldUrl = [];

                    upld_s = await _upld_s;
                    aUpldUrl.push(_generateImageUrl(oFile['signedUrls'][0].key));

                    upld_m = await _upld_m;
                    aUpldUrl.push(_generateImageUrl(oFile['signedUrls'][1].key));

                    upld_l = await _upld_l;
                    aUpldUrl.push(_generateImageUrl(oFile['signedUrls'][2].key));

                    aFileList[i].uploadUrls = aUpldUrl;
                    oStage.uploadReady      = true;

                // setResFiles(aResFiles);
                // setFileState({...fileState, uploadReady: aResFiles.length === i+1 ? true : false });
                
            };



            // update state
            setFilesState({...filesState, 
                                fileList: aFileList,
                                stage   : { ...filesState.stage,
                                            signReady: oStage.signReady,
                                            uploadReady : oStage.uploadReady
                                        }
                            });

            return(aFileList);


        } catch(e) {
            console.log(e);
            alert('Technical Error. Failed to Upload Media');
        }
    }


    const onRmoveFile = (oFile) => {
        let upFiles     = filesState['fileList'].filter( obj => obj.name !== oFile.name );
        let updFiles64  = filesState['fileList64'].filter( obj => obj.name !== oFile.name );

         setFilesState({...filesState, 
                            fileList:upFiles,
                            fileList64:updFiles64,
                            stage: {...filesState.stage, 
                                        attachReady: upFiles.length > 0 ? true : false,
                                        resizeReady:upFiles.length > 0 ? true : false 
                                    } 
                        });

    };

    const resetMedia = () => {
        setFilesState(initState);
    }


/**********************************************************************
 * Internal Methods:
 ********************************************************************** */

    const onCheckState = (oEvent) => {
        console.log(filesState,"general comp state");
        }

    const _promiseTerminate = async (aList) => {
        let aResList   = [],
            aResList64 = [];

        for( let i=0; i < aList.length; i++ ) {

            let oPrmFile = aList[i];

            // result in base64
            let prmS = await oPrmFile.promises[0];
            let prmM = await oPrmFile.promises[1];
            let prmL = await oPrmFile.promises[2];

            // convert to blob:
            let blobS = await _base64ToBloc(prmS);
            let blobM = await _base64ToBloc(prmM);
            let blobL = await _base64ToBloc(prmL);

            let oResFile64 = {name: oPrmFile.name, origFile: oPrmFile.origFile, files: [prmS,prmM,prmL]}; // needed for getDimension Method
            let oResFile   = {name: oPrmFile.name, origFile:oPrmFile.origFile, files: [blobS,blobM,blobL],reqURls:[],signedUrls:[],uploadUrls:[]};
  
            aResList.push(oResFile);
            aResList64.push(oResFile64);

        };

        setFilesState({...filesState, fileList:aResList, fileList64:aResList64, stage: {...filesState.stage, attachReady:true, resizeReady:true} });

        return(aResList);
    }

    const _base64ToBloc = async (base64DataUrl) => {
        // Fetch the data URL
        try {
            const response = await fetch(base64DataUrl);
            const blob     = await response.blob();

            return blob;

            } catch(e) {
                console.log(e);
                alert('failed to convert base64 to blob');
        }

    }

    const _generateImageUrl = (sKey) => {
        let sUrl = `https://beetko-img-upload.s3.eu-central-1.amazonaws.com/${sKey}`;
        return(sUrl);
    }

/**********************************************************************
 * JSX View
 ********************************************************************** */

    return(
            <SectionContainer uploadUrls={props}>
                <SectionTitle variant="h5">Images</SectionTitle>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 0, sm: 0, md: 2 }} disableGutters>
                    <Grid size={{xs: 12, md: 12  , lg:12}}>
                        <UplBtnCtnr>   
                            <UploadButton name="media" onFileChange={onFileChange} text={'Images'}></UploadButton>
                            {/* <Button startIcon={<CloudUploadIcon sx={{marginLeft:1, textTransform: 'none'}} />}  onClick={onProcessUpload} variant="outlined" color="success">Upload</Button> */}
                            {/* <Button  variant="contained" color="info" onClick={resizeImages}> resize</Button> */}
                            {/* <Button onClick={onUpload} variant="contained" color="success">Upload S3</Button> */}
                            <Divider/>
                            <Button  variant="contained" color="warning" onClick={onCheckState}>log state</Button>
                        </UplBtnCtnr>

                        <SelImagesCtnr>
                            {
                                filesState['fileList'].map( (oFile,i) => {
                                    return(
                                        <ImgCntnr>
                                            <ImgBox component="img" src={URL.createObjectURL(oFile.origFile)} ></ImgBox>
                                            <Button 
                                                name="mediaMedium"
                                                color="error"
                                                variant="text"
                                                key={i}
                                                onClick={ (oEvent) => onRmoveFile(oFile)}>
                                                    remove
                                                    {/* {fileState.uploadReady ? 'uploaded' : 'remove' } */}
                                            </Button>
                                        </ImgCntnr>
                                    )
                                } )
                            }

                        </SelImagesCtnr>  
                    </Grid>

                </Grid>

                <InfoPanelCntr dir="rtl">
                    <SectionTitle variant="h5">status</SectionTitle>
                    <ControlLabel sx={{width:'10rem'}}>Files attached:{filesState['fileList'].length}</ControlLabel>
                    <Divider/>
                    <ControlLabel sx={{width:'10rem'}}>Files Resized:{filesState['fileList'].length}</ControlLabel>
                    <Divider/>
                    {/* 
                    <ControlLabel sx={{width:'15rem'}}>SignedURL received:{aSignedUrl.length}</ControlLabel>
                    <Divider/>
                    <ControlLabel sx={{width:'10rem'}}>Image Url received:{aUploadUrl.length}</ControlLabel> */}
                </InfoPanelCntr>

                {/* <Box component={'image'} src={aUploadUrl[0]}></Box> */}
                {/* <ImgBox component="img"
                         src={!aResFiles[0].uploadUrls[0] ? undefined :  aResFiles[0].uploadUrls[0] } 
                         display={aUploadUrl.length > 0 ? 'block' : 'none'}></ImgBox> */}

            </SectionContainer>

    );
})

export default ImageUploader6;